import {Table, Text} from '@mantine/core'
import {ProjectBadge} from '../calendar/components/badges/ProjectBadge.tsx'
import type {Project} from '@package/shared'

type Props = {project: Project; onClick: () => void}

export const ProjectRow = ({project, onClick}: Props) => {
  return (
    <Table.Tr key={project.id} onClick={onClick} style={{cursor: 'pointer'}}>
      <Table.Td width={25}>
        <ProjectBadge projectId={project.id} compact />
      </Table.Td>

      <Table.Td style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
        <Text c={project.archivedTime ? 'dimmed' : undefined}>{project.name}</Text>
      </Table.Td>
    </Table.Tr>
  )
}
